"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.orderByLastReceived = exports.groupByCurrency = exports.getNFT = exports.metadataCallBatcher = exports.getNftCollectionKey = exports.getNftKey = exports.nftsByCollections = exports.nftsFromOperations = void 0;
var eip55_1 = __importDefault(require("eip55"));
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var nftId_1 = require("@ledgerhq/coin-framework/nft/nftId");
var account_1 = require("../account");
var Ethereum_1 = require("../api/Ethereum");
var nftsFromOperations = function (ops) {
    var nftsMap = ops
        .slice(0)
        // make sure we have the operation in chronological order (older first)
        .sort(function (a, b) { return a.date.getTime() - b.date.getTime(); })
        // if ops are Operations get the prop nftOperations, else ops are considered nftOperations already
        .flatMap(function (op) { var _a; return (((_a = op === null || op === void 0 ? void 0 : op.nftOperations) === null || _a === void 0 ? void 0 : _a.length) ? op.nftOperations : op); })
        .reduce(function (acc, nftOp) {
        var contract = nftOp.contract;
        if (!contract) {
            return acc;
        }
        // Creating a "token for a contract" unique key
        contract = eip55_1["default"].encode(contract);
        var tokenId = nftOp.tokenId, standard = nftOp.standard, accountId = nftOp.accountId;
        var currencyId = (0, account_1.decodeAccountId)(nftOp.accountId).currencyId;
        if (!tokenId || !standard)
            return acc;
        var id = (0, nftId_1.encodeNftId)(accountId, contract, tokenId, currencyId);
        var nft = (acc[id] || {
            id: id,
            tokenId: tokenId,
            amount: new bignumber_js_1["default"](0),
            contract: contract,
            standard: standard,
            currencyId: currencyId
        });
        if (nftOp.type === "NFT_IN") {
            nft.amount = nft.amount.plus(nftOp.value);
        }
        else if (nftOp.type === "NFT_OUT") {
            var newAmount = nft.amount.minus(nftOp.value);
            // In case of OpenSea lazy minting feature (minting an NFT off-chain)
            // OpenSea will fire a false ERC1155 event saying that you sent an NFT
            // from your account that you never received first.
            //
            // E.g.: I'm creating 10 ERC1155 on OpenSea. It's not going to create anything on-chain.
            // Then I (bob) decide to transfer 5 to someone (kvn). OpenSea is going to mint the NFT in its
            // collection (`OpenSea Shared Storefront` / `OpenSea Collections`) and transfer it to kvn.
            // But the event fired by the Smart Contract is going to be `bob transfered 5 NFT to kvn` which is false.
            // It would then result in bob have -5 NFTs since he never received them first.
            // If kvn send 2 back to bob, based on the events we would think that bob has -3 NFTs.
            //
            // To mitigate that we put a minimum value of 0 when an account is transferring some NFTs.
            nft.amount = newAmount.isNegative() ? new bignumber_js_1["default"](0) : newAmount;
        }
        acc[id] = nft;
        return acc;
    }, {});
    // We reverse the array to make it from latest to oldest again
    return Object.values(nftsMap).reverse();
};
exports.nftsFromOperations = nftsFromOperations;
/**
 * Helper to group NFTs by their collection/contract.
 *
 * It will either return an object { [contract address]: NFT[] }
 * or if you specify a collectionAddress it will simply filter
 * your NFTs for this specific contract and return an NFT[].
 *
 * The grouping here can be done with ProtoNFT or NFT.
 */
var nftsByCollections = function (nfts, collectionAddress) {
    if (nfts === void 0) { nfts = []; }
    return collectionAddress
        ? nfts.filter(function (n) { return n.contract === collectionAddress; })
        : nfts.reduce(function (acc, nft) {
            var contract = nft.contract;
            if (!acc[contract]) {
                acc[contract] = [];
            }
            acc[contract].push(nft);
            return acc;
        }, {});
};
exports.nftsByCollections = nftsByCollections;
var getNftKey = function (contract, tokenId, currencyId) {
    return "".concat(currencyId, "-").concat(contract, "-").concat(tokenId);
};
exports.getNftKey = getNftKey;
var getNftCollectionKey = function (contract, currencyId) {
    return "".concat(currencyId, "-").concat(contract);
};
exports.getNftCollectionKey = getNftCollectionKey;
/**
 * Factory to make a metadata API call batcher.
 *
 * It will wait for a complete `tick` to accumulate all the metadata requests
 * before sending it as one call to a given API.
 * Once the response is received, it will then spread the metadata to each request Promise,
 * just like if each request had been made separately.
 */
var makeBatcher = function (call, chainId) {
    return (function () {
        var queue = [];
        var debounce;
        var timeoutBatchCall = function () {
            // Clear the previous scheduled call if it was existing
            clearTimeout(debounce);
            // Schedule a new call with the whole batch
            debounce = setTimeout(function () {
                // Seperate each batch element properties into arrays by type and index
                var _a = queue.reduce(function (acc, _a) {
                    var element = _a.element, resolve = _a.resolve, reject = _a.reject;
                    acc.elements.push(element);
                    acc.resolvers.push(resolve);
                    acc.rejecters.push(reject);
                    return acc;
                }, { elements: [], resolvers: [], rejecters: [] }), elements = _a.elements, resolvers = _a.resolvers, rejecters = _a.rejecters;
                // Empty the queue
                queue.length = 0;
                // Make the call with all the couples of contract and tokenId at once
                call(elements, chainId.toString())
                    .then(function (res) {
                    // Resolve each batch element with its own resolver and only its response
                    res.forEach(function (metadata, index) { return resolvers[index](metadata); });
                })["catch"](function (err) {
                    // Reject all batch element with the error
                    rejecters.forEach(function (reject) { return reject(err); });
                });
            });
        };
        return {
            // Load the metadata for a given couple contract + tokenId
            load: function (element) {
                return new Promise(function (resolve, reject) {
                    queue.push({ element: element, resolve: resolve, reject: reject });
                    timeoutBatchCall();
                });
            }
        };
    })();
};
var batchersMap = new Map();
/**
 * In order to `instanciate`/make only 1 batcher by currency,
 * they're `cached` in a Map and retrieved by this method
 * This method is still EVM based for now but can be improved
 * to implement an even more generic solution
 */
var metadataCallBatcher = function (currency) {
    var _a;
    var api = (0, Ethereum_1.apiForCurrency)(currency);
    var chainId = (_a = currency === null || currency === void 0 ? void 0 : currency.ethereumLikeInfo) === null || _a === void 0 ? void 0 : _a.chainId;
    if (!chainId || !api) {
        throw new Error("Ethereum: No API or chainId for this Currency");
    }
    if (!batchersMap.has(currency.id)) {
        batchersMap.set(currency.id, {
            nft: makeBatcher(api.getNFTMetadata, chainId),
            collection: makeBatcher(api.getNFTCollectionMetadata, chainId)
        });
    }
    var batchers = batchersMap.get(currency.id);
    return {
        loadNft: batchers.nft.load,
        loadCollection: batchers.collection.load
    };
};
exports.metadataCallBatcher = metadataCallBatcher;
var getNFT = function (contract, tokenId, nfts) {
    return nfts === null || nfts === void 0 ? void 0 : nfts.find(function (nft) { return nft.contract === contract && nft.tokenId === tokenId; });
};
exports.getNFT = getNFT;
var SUPPORTED_CURRENCIES = ["ethereum", "polygon"];
var groupByCurrency = function (nfts) {
    var groupMap = new Map();
    SUPPORTED_CURRENCIES.forEach(function (elem) { return groupMap.set(elem, []); });
    // GROUPING
    nfts.forEach(function (nft) {
        var _a;
        var currency = nft.currencyId;
        var group = (_a = groupMap.get(currency)) !== null && _a !== void 0 ? _a : [];
        group === null || group === void 0 ? void 0 : group.push(nft);
        groupMap.set(currency, group);
    });
    return Array.from(groupMap, function (_a) {
        var _b = __read(_a, 2), _key = _b[0], value = _b[1];
        return value;
    }).flat();
};
exports.groupByCurrency = groupByCurrency;
function orderByLastReceived(accounts, nfts) {
    var orderedNFTs = [];
    var operationMapping = [];
    var res = (0, account_1.groupAccountsOperationsByDay)(accounts, {
        count: Infinity
    });
    // Sections are sorted by Date, the most recent being the first
    res.sections.forEach(function (section) {
        // Get all operation linked to the reception of an NFT
        var operations = section.data.filter(function (d) { return d.type === "NFT_IN" && d.contract && d.tokenId; });
        operationMapping = operationMapping.concat(operations);
    });
    operationMapping.forEach(function (operation) {
        // Prevent multiple occurences due to Exchange Send/Receive same NFT several times
        var isAlreadyIn = orderedNFTs.find(function (nft) {
            return nft.contract === operation.contract && nft.tokenId === operation.tokenId;
        });
        if (!isAlreadyIn) {
            var nft = (0, exports.getNFT)(operation.contract, operation.tokenId, nfts);
            if (nft)
                orderedNFTs.push(nft);
        }
    });
    return (0, exports.groupByCurrency)(__spreadArray([], __read(new Set(orderedNFTs)), false));
}
exports.orderByLastReceived = orderByLastReceived;
//# sourceMappingURL=helpers.js.map